// project settings, you can change only PROJECT_NAME, BASE_URL and WEBSITE_URL otherwise it can break the app
export const PROJECT_NAME = 'foodiecity marketplace';
export const BASE_URL =
process.env.REACT_APP_BASE_URL || 'https://backend.foodiecity.store';
export const WEBSITE_URL = 'https://foodiecity.store';
export const api_url = BASE_URL + '/api/v1/';
export const api_url_admin = BASE_URL + '/api/v1/dashboard/admin/';
export const api_url_admin_dashboard = BASE_URL + '/api/v1/dashboard/';
export const IMG_URL = '';
export const export_url = BASE_URL + '/storage/';
export const example = BASE_URL + '/';

// map api key, ypu can get it from https://console.cloud.google.com/apis/library
export const MAP_API_KEY = 'AIzaSyDE8rILNDDFo_uQzYf2edAakp1XjCLRzOE';

// firebase keys, do not forget to change to your own keys here and in file public/firebase-messaging-sw.js
export const VAPID_KEY =
  'BK0tr2i4rgBvP86loh0DBZZ6b9oyxDvlskX7EeKa85YWN4Di976R7JstcWhFM5_EcJI5yGuiL6VHAL0oQihoLxc';
export const API_KEY = 'AIzaSyB2km3xPsLcpsSVBaDk5wN_LwfssM85tPQ';
export const AUTH_DOMAIN = 'foodiecity-a8567.firebaseapp.com';
export const PROJECT_ID = 'foodiecity-a8567';
export const STORAGE_BUCKET = 'foodiecity-a8567.appspot.com';
export const MESSAGING_SENDER_ID = '498889755317';
export const APP_ID = '1:498889755317:web:859b1edcd1a1ebe6210cfc';
export const MEASUREMENT_ID = 'G-MDBC9P8KSP';

// recaptcha key, you can get it from https://www.google.com/recaptcha/admin/create
export const RECAPTCHASITEKEY = '6LexHkcrAAAAACkegblMkYapoGDHRX4eoSikPUwE';

// demo data, no need to change
export const LAT = 47.4143302506288;
export const LNG = 8.532059477976883;
export const DEMO_SELLER = 334; // seller_id
export const DEMO_SELLER_UUID = '3566bdf6-3a09-4488-8269-70a19f871bd0'; // seller_id
export const DEMO_SHOP = 599; // seller_id
export const DEMO_DELIVERYMAN = 375; // deliveryman_id
export const DEMO_MANEGER = 114; // deliveryman_id
export const DEMO_MODERATOR = 297; // deliveryman_id
export const DEMO_ADMIN = 107; // deliveryman_id
export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/svg',
];

// QR server URL (optional) - frontend will open this service to download QR images
export const QR_SERVER_URL = process.env.REACT_APP_QR_SERVER || 'http://localhost:3001';
